import React from "react";
import {
  Box,
  Typography,
  Breadcrumbs,
  Link,
  Button,
  Paper,
} from "@mui/material";
import "../styles/memoHebdo.css";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import HomeIcon from "@mui/icons-material/Home";
import ArticleIcon from "@mui/icons-material/Article";
import AddIcon from "@mui/icons-material/Add";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

// FORM
import ArticleForm from "../components/ArticleForm";

function CreateArticle() {
  const { t } = useTranslation(["memohebdo"]);
  const userState = useSelector((state) => state.user);
  const navigate = useNavigate();
  const token = userState.token;

  return (
    <Box sx={{ p: 3 }}>
      {/* ================= HEADER ================= */}
      <Box className="mh-header-card">
        {/* TOP BLUE BAR */}
        <Box className="mh-header-topbar" />

        {/* CONTENT */}
        <Box className="mh-header-content">
          {/* TITLE ROW */}
          <Box className="mh-header-title-row">
            {/* LEFT */}
            <Box>
              <Typography className="mh-subtitle">
                {t("memoHebdo.createPage.subtitle")}
              </Typography>
            </Box>

            {/* RIGHT */}
            <Button
              startIcon={<ArrowBackIcon />}
              variant="outlined"
              onClick={() => navigate("/ArticleManagement")}
              sx={{
                textTransform: "none",
                borderRadius: "12px",
                fontWeight: 700,
                px: 2.5,
              }}
            >
              {t("memoHebdo.buttons.back")}
            </Button>
          </Box>

          {/* BREADCRUMBS */}
          <Breadcrumbs>
            <Link
              underline="hover"
              sx={{
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
              }}
              onClick={() => navigate("/")}
            >
              <HomeIcon sx={{ mr: 0.5 }} fontSize="small" />
              {t("memoHebdo.breadcrumbs.home")}
            </Link>

            <Link
              underline="hover"
              sx={{
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
              }}
              onClick={() => navigate("/ArticleManagement")}
            >
              <ArticleIcon sx={{ mr: 0.5 }} fontSize="small" />
              {t("memoHebdo.breadcrumbs.articleManagement")}
            </Link>

            <Typography
              sx={{
                display: "flex",
                alignItems: "center",
              }}
              color="text.primary"
            >
              <AddIcon sx={{ mr: 0.5 }} fontSize="small" />
              {t("memoHebdo.breadcrumbs.create")}
            </Typography>
          </Breadcrumbs>
        </Box>
      </Box>

      {/* ================= CONTENT ================= */}
      <Paper
        elevation={2}
        sx={{
          p: 3,
          borderRadius: 3,
        }}
      >
        <ArticleForm token={token} />
      </Paper>
    </Box>
  );
}

export default CreateArticle;
